export default __webpack_public_path__ + "static/media/ThrobacLogoFIN.2a58ac9f.mp4";